import { ButtonBase, styled, Typography } from '@mui/material';
import { Stack } from '@mui/material';
import { ElementType } from 'react';
import { ImageProps } from '../../images';

const Button = styled(ButtonBase)(({ theme }) => ({
  boxShadow: `0px 2px 4px 0px rgba(121, 153, 171, 0.12), 0px 1px 1px 0px rgba(121, 153, 171, 0.12)`,
  borderRadius: Number(theme.shape.borderRadius ?? 0) * 2,
  transition: theme.transitions.create('border'),
  border: `3px solid ${theme.palette.background.paper}`,

  '&:hover': {
    border: `3px solid ${theme.palette.info.main}`,
  },
}));

const Description = styled('div')({
  textAlign: 'left',
});

export function BigVariantButton<Variant>({
  variant,
  graphics,
  title,
  description,
  onClick,
}: {
  variant: Variant;
  title: string;
  graphics: ElementType<ImageProps>;
  description: string;
  onClick: (variant: Variant) => void;
}) {
  const Graphics = graphics;

  return (
    <Button onClick={() => onClick(variant)}>
      <Stack alignItems="start" padding={6}>
        <Graphics width={120} />
        <Description>
          <Typography variant="subtitle2">{title}</Typography>
          <Typography>{description}</Typography>
        </Description>
      </Stack>
    </Button>
  );
}
